module.exports = __webpack_public_path__ + "ba705a9df128062764427e2b5c046de5.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/head/festival.jpg
// module id = 485
// module chunks = 0